import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// src
import * as routes from '../../routes/routes_production.js';

// 1) component: Component
// prende il valore di props.component e lo assegna ad una nuova variabile 
// nominandola per convenzione con l'Uppercase

// 2) ...rest (spread operator) 
// prende tutte le proprietà in 'props', escluse quelle presenti fra i parametri,
// e le salva in un nuovo oggetto chiamato 'rest'

// se un componente è privato e viene visitato senza autenticazione,
// bisogna effettuare il redirect alla pagina di login mediante la landing page
const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={() => (rest.auth() !== null)
      ? <Component {...rest} />
      : <Redirect to={routes.LANDING} />      
    } />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/cmp/Routing/PrivateRoute.js